<template>
  <div id="app">
    <div class="flight-start-jumbotron">
      <div class="container p-xl-0">
        <el-form :inline="true" class="search-condition-form" label-position="top">
          <div class="flight-start-wrapper flex-xl-row flex-column">
            <div  class="marketing-text">
              <h1 class="title">
                JISO Travel
              </h1>
              <div class="subtitle">
                Your next memorable trip starts here
              </div>
            </div>
            <div class="search-condition-block">
                <b-card no-body content-class="mt-3" header-variant="card_header" footer-variant="card_footer"
                  title-variant="card_title" justified>
                  <b-tabs pills card active-nav-item-class="" class="font-weight-medium">
                    <b-tab active>
                      <template v-slot:title>
                        <span class="tab-title-class">
                          <font-awesome-icon icon="suitcase" size="xs" />Trip</span>
                      </template>
                      <div class="search-form d-flex">
                        <div class="seach">
                          <div class="mb-3">
                            <el-input :debounce="300" class="city-text-field"
                              placeholder="Search by Country, Province, City, Zip Code, Attraction Name, Attraction Type">
                              <font-awesome-icon icon="search" size="s" slot="prefix" />
                              <template slot="append" class="px-0">
                                <el-button @click.prevent="submitSearchTrip(data)" type="primary">Search</el-button>
                              </template>
                            </el-input>
                          </div>
                        </div>
                      </div>
                      <div class="row d-flex search-form transparent-form">
                        <div style="width: 100px;">
                          <el-select class="date" multiple placeholder="Duration" value="">
                            <el-option value="">
                              <DepartureArrival :mydate="dateValue" />
                            </el-option>
                          </el-select>
                        </div>
                        <div style="width: 115px;">
                          <el-select multiple collapse-tags placeholder="Preference"
                            v-model="multiSelect">
                            <el-option v-for="item in items" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                          </el-select>
                        </div>
                        <div style="width: 120px;">
                          <el-select v-model="value" placeholder="Group Type">
                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                              :value="item.value" />
                          </el-select>
                        </div>
                        <div style="width: 215px;">
                          <el-select multiple
                            :placeholder="num1+' '+`Adult`+', '+num2+' '+`Child`+', '+num3+' '+`Infants`" value="">
                            <el-option class="d-flex mt-4" value="">
                              <h6 class="pr-3" style="width: 75px;">Adult(s)</h6>
                              <el-input-number class="ml-auto" v-model="num1" :min="0" :max="6"></el-input-number>
                            </el-option>
                            <el-option class="d-flex mt-4" value="">
                              <div class="flex-column" style="line-height: 0.75;">
                                <h6 class="pr-3" style="width: 75px;">Child(s)</h6>
                                <small>(Ages 2-11)</small>
                              </div>
                              <el-input-number class="ml-auto" v-model="num2" :min="0" :max="6">
                              </el-input-number>
                            </el-option>
                            <el-option class="d-flex my-4" value="">
                              <div class="flex-column" style="line-height: 0.75;">
                                <h6 class="pr-3" style="width: 75px;"> Infants</h6>
                                <small>(0-1)</small>
                              </div>
                              <el-input-number class="ml-auto" v-model="num3" :min="0" :max="1">
                              </el-input-number>
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </b-tab>
                    <b-tab>
                      <template v-slot:title>
                        <span class="tab-title-class">
                          <font-awesome-icon icon="parachute-box" size="xs" />Attractions</span>
                      </template>

                      <div class="search-form d-flex">
                        <div class="seach">
                          <div class="mb-3">
                            <el-input :debounce="300" class="city-text-field"
                              placeholder="Search by Country, Province, City, Zip Code, Attraction Name, Attraction Type">
                              <font-awesome-icon icon="search" size="s" slot="prefix" />
                              <template slot="append" class="px-0">
                                <el-button @click.prevent="submitSearchTrip" type="primary">Search</el-button>
                              </template>
                            </el-input>
                          </div>
                        </div>
                      </div>

                      <div class="row d-flex search-form transparent-form">
                        <div style="width: 100px;">
                          <el-select class="date" multiple placeholder="Duration" value="">
                            <el-option value="">
                              <DepartureArrival />
                            </el-option>
                          </el-select>
                        </div>
                        <div style="width: 115px;">
                          <el-select multiple collapse-tags placeholder="Preference"
                            v-model="multiSelect">
                            <el-option v-for="item in items" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                          </el-select>
                        </div>
                        <div style="width: 120px;">
                          <el-select v-model="value" placeholder="Group Type">
                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                              :value="item.value" />
                          </el-select>
                        </div>
                        <div style="width: 215px;">
                          <el-select multiple
                            :placeholder="num4+' '+`Adult`+', '+num5+' '+`Child`+', '+num6+' '+`Infants`" value="">
                            <el-option class="d-flex mt-4" value="">
                              <h6 class="pr-3" style="width: 75px;">Adult(s)</h6>
                              <el-input-number class="ml-auto" v-model="num4" :min="0" :max="6"></el-input-number>
                            </el-option>
                            <el-option class="d-flex mt-4" value="">
                              <div class="flex-column" style="line-height: 0.75;">
                                <h6 class="pr-3" style="width: 75px;">Child(s)</h6>
                                <small>(Ages 2-11)</small>
                              </div>
                              <el-input-number class="ml-auto" v-model="num5" :min="0" :max="6">
                              </el-input-number>
                            </el-option>
                            <el-option class="d-flex my-4" value="">
                              <div class="flex-column" style="line-height: 0.75;">
                                <h6 class="pr-3" style="width: 75px;"> Infants</h6>
                                <small>(0-1)</small>
                              </div>
                              <el-input-number class="ml-auto" v-model="num6" :min="0" :max="1">
                              </el-input-number>
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </b-tab>
                    <b-tab>
                      <template v-slot:title>
                        <span class="tab-title-class">
                          <font-awesome-icon icon="hotel" size="xs" />Hotels</span>
                      </template>

                      <div class="search-form d-flex flex-md-nowrap flex-wrap hotel">
                        <div class="d-flex hotel-input">
                          <div class="align-items-center w-100">
                            <el-input :debounce="300" class="city-text-field"
                              placeholder="Destination or property name">
                              <font-awesome-icon icon="search" size="s" slot="prefix" />
                            </el-input>
                          </div>
                          <CheckinCheckOut class="mx-md-3 ml-md-0 ml-3 date" />
                        </div>
                        <div class="d-flex transfer-right">
                          <el-select multiple :debounce="300" class="city-text-field mr-3"
                            :placeholder="num7+' '+`Adult`+', '+num8+' '+`children`+', '+num9+' '+`Room`" value="">
                            <font-awesome-icon icon="user" size="s" slot="prefix" />
                            <el-option class="d-flex mt-4" value="">
                              <h6 class="pr-3" style="width: 75px;">Rooms</h6>
                              <el-input-number class="ml-auto" v-model="num7" :min="0" :max="6"></el-input-number>
                            </el-option>
                            <el-option class="d-flex mt-4" value="">
                              <div class="flex-column" style="line-height: 0.75;">
                                <h6 class="pr-3" style="width: 75px;">Adults</h6>
                              </div>
                              <el-input-number class="ml-auto" v-model="num8" :min="0" :max="6">
                              </el-input-number>
                            </el-option>
                            <el-option class="d-flex mt-4" value="">
                              <div class="flex-column" style="line-height: 0.75;">
                                <h6 class="pr-3" style="width: 75px;">Children</h6>
                              </div>
                              <el-input-number class="ml-auto" v-model="num9" :min="0" :max="1">
                              </el-input-number>
                            </el-option>
                          </el-select>
                          <el-button @click.prevent="submitSearchTrip" type="primary">Search
                          </el-button>
                        </div>
                      </div>

                    </b-tab>
                    <b-tab>
                      <template v-slot:title>
                        <span class="tab-title-class">
                          <font-awesome-icon icon="plane" size="xs" />Flights</span>
                      </template>

                      <div class="search-form d-flex">
                        <div class="radio-group form-group d-flex flex-sm-nowrap flex-wrap">
                          <el-radio label="R">Roundtrip</el-radio>
                          <el-radio label="O" class="ml-sm-3">One Way</el-radio>
                          <el-select class="ml-sm-3 ml-0 mt-sm-0 mt-2" v-model="value"
                            placeholder="Person">
                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                              :value="item.value" />
                          </el-select>
                        </div>
                      </div>

                      <div class="search-form">
                        <div class="row d-flex px-3">
                          <div class="d-flex transfer-input">
                            <el-form-item>
                              <CityTextField name="origin" />
                            </el-form-item>
                            <div class="mx-sm-0 mx-auto px-3">
                              <button type="butoon"
                                class="btn btn-theme d-flex align-items-center justify-content-center ">
                                <img src="@/assets/icons/exchange-alt-solid.svg" width="28px"></button>
                            </div>
                            <el-form-item>
                              <CityTextField name="destination" />
                            </el-form-item>
                          </div>
                          <div class="d-flex transfer-right">
                            <DepartureArrival class="px-lg-3 pl-0 pr-3" />
                            <el-button @click.prevent="submitSearchFlight" type="primary">Find Flights</el-button>
                          </div>
                        </div>
                      </div>

                    </b-tab>
                    <b-tab>
                      <template v-slot:title>
                        <span class="tab-title-class">
                          <font-awesome-icon icon="snowboarding" size="xs" />Activities</span>
                      </template>

                      <div class="search-form d-flex">
                        <div class="seach">
                          <div class="mb-3">
                            <el-input :debounce="300" class="city-text-field"
                              placeholder="Search by Country, Province, City, Zip Code, Attraction Name, Attraction Type">
                              <font-awesome-icon icon="search" size="s" slot="prefix" />
                              <template slot="append" class="px-0">
                                <el-button @click.prevent="submitSearchTrip" type="primary">Search</el-button>
                              </template>
                            </el-input>
                          </div>
                        </div>
                      </div>

                      <div class="row search-form transparent-form d-flex">
                        <div style="width: 100px;">
                          <el-select class="date" multiple placeholder="Duration" value="">
                            <el-option value="">
                              <DepartureArrival />
                            </el-option>
                          </el-select>
                        </div>
                        <div style="width: 115px;">
                          <el-select multiple collapse-tags placeholder="Preference"
                            v-model="multiSelect">
                            <el-option v-for="item in items" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                          </el-select>
                        </div>
                      </div>

                    </b-tab>
                    <b-tab>
                      <template v-slot:title>
                        <span class="tab-title-class">
                          <font-awesome-icon icon="bus" size="xs" />Transportations</span>
                      </template>

                      <div class="search-form d-flex">
                        <div class="seach">
                          <div class="mb-3">
                            <el-input :debounce="300" class="city-text-field"
                              placeholder="Search by Country, Province, City, Airport">
                              <font-awesome-icon icon="search" size="s" slot="prefix" />
                              <template slot="append" class="px-0">
                                <el-button @click.prevent="submitSearchTrip" type="primary">Search</el-button>
                              </template>
                            </el-input>
                          </div>
                        </div>
                      </div>

                      <div class="row d-flex search-form transparent-form">
                        <div style="width: 100px;">
                          <el-select class="date" multiple placeholder="Duration" value="">
                            <el-option value="">
                              <DepartureArrival />
                            </el-option>
                          </el-select>
                        </div>
                        <div style="width: 140px;">
                          <el-select v-model="value" placeholder="Transportation Method">
                            <el-option v-for="item in transport" :key="item.value" :label="item.label"
                              :value="item.value" />
                          </el-select>
                        </div>
                        <div style="width: 215px;">
                          <el-select multiple
                            :placeholder="num1+' '+`Adult`+', '+num2+' '+`Child`+', '+num3+' '+`Infants`" value="">
                            <el-option class="d-flex mt-4" value="">
                              <h6 class="pr-3" style="width: 75px;">Adult(s)</h6>
                              <el-input-number class="ml-auto" v-model="num1" :min="0" :max="6"></el-input-number>
                            </el-option>
                            <el-option class="d-flex mt-4" value="">
                              <div class="flex-column" style="line-height: 0.75;">
                                <h6 class="pr-3" style="width: 75px;">Child(s)</h6>
                                <small>(Ages 2-11)</small>
                              </div>
                              <el-input-number class="ml-auto" v-model="num2" :min="0" :max="6">
                              </el-input-number>
                            </el-option>
                            <el-option class="d-flex my-4" value="">
                              <div class="flex-column" style="line-height: 0.75;">
                                <h6 class="pr-3" style="width: 75px;"> Infants</h6>
                                <small>(0-1)</small>
                              </div>
                              <el-input-number class="ml-auto" v-model="num3" :min="0" :max="1">
                              </el-input-number>
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </b-tab>
                  </b-tabs>
                </b-card>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <br>
    <br>
    <div class="container mb-5">
      <!-- <div class="row information-container my-5 py-3"> -->
      <div>
        <img src="../assets/images/infographic-jiso.jpg" style="width: 100%" />
      </div>
    </div>
    <div class="container mb-5">
      <HomeInfluencerPresetTabs />
    </div>
    <div class="container partners my-5">
      <header class="mb-5">
				<h2 class="text-center">Our Partners</h2>
			</header>
			<carousel autoplayDirection="forward" :autoplayHoverPause="true" :paginationEnabled="false" :autoplayTimeout="5000" :autoplay="true" :navigationEnabled="true" navigationNextLabel="<i class='fas fa-chevron-right'></i>" navigationPrevLabel="<i class='fas fa-chevron-left'></i>" :loop="true" :perPageCustom="[[1, 3], [577, 4], [768, 4], [992, 4], [1044, 6], [1200, 6]]">
				<slide v-for="object in objects" :key="object.id">
					<div class="partners-child d-flex align-items-center justify-content-center">
            <img class="partners-image" :src="object.image" width="120px">
          </div>
				</slide>
			</carousel>
    </div>
    <div class="container-fluid px-0 pt-5">
      <footer class="footer">
        <div class="container">
          <div class="footer-inner">
            <div class="row footer-content">
              <div class="col-lg-2">
                <ul>
                  <li>JISO Travel</li>
                  <li>About</li>
                  <li>Blog</li>
                  <li>Join our team</li>
                </ul>
              </div>
              <div class="col-lg-2 mt-3 mt-lg-0">
                <ul>
                  <li>Discover more</li>
                  <li>Plans</li>
                  <li>Destinations</li>
                </ul>
              </div>
              <div class="col-lg-2 mt-3 mt-lg-0">
                <ul>
                  <li>Help</li>
                  <li>FAQS</li>
                  <li>Contact us</li>
                  <li>Terms & Conditions</li>
                  <li>Privacy Policy</li>
                </ul>
              </div>
              <div class="col-lg-3 ml-lg-auto offset-0 mt-3 mt-lg-0">
                <div class="contact">
                  <div class="social-icon">
                    <span class="icon"><i class="fab fa-facebook-f"></i></span>
                    <span class="icon mx-4 px-2"><i class="fab fa-youtube"></i></span>
                    <span class="icon"><i class="fab fa-instagram"></i></span>
                  </div>
                  <div class="subtitle my-4">I would love to hear further stories from JISO. Please keep in touch with me via</div>
                  <div class="form-group">
                    <input type="email" class="form-control" placeholder="Email address">
                    <span class="icon"><i class="fas fa-arrow-right"></i></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="copyright">
              <img class="mr-3" src="@/assets/images/footer-logo-jiso.png" width="26px">
              <span>Copyright @ 2018 JISO - All Rights Reserved.</span>
            </div>
          </div>
        </div>
        <img src="@/assets/images/icon-jiso-footer.png" class="footer-bg">
      </footer>
    </div>

  <transition name="modal">
    <div v-if="!dialogVisible" class="modal d-flex" @click.self="dialogVisible = false">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="col-12 d-flex justify-content-end p-0">
              <button @click="dialogVisible = false" type="button" class="close p-0" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="col-12 mt-2 p-0">
                <h5 class="text-center">Welcome To Jiso Travel</h5>
                <div class="text-group">
                  <div class="text-center mt-5">รับทันที! คูปองส่วนลดมูลค่า 1,000 บาท</div>
                  <div class="text-center">เพียงกรอกอีเมล์เพื่อลงทะเบียน ภายในงาน "เที่ยวญี่ปุ่นด้วยตัวเอง 2019</div>
                  <div class="form-group">
                    <el-input class="emailinput my-4 mx-auto d-flex" placeholder="Your E-mail" v-model="email" />
                  </div>
                  <div class="text-center">*หมายหตุ: คูปองส่วนลดนี้สามารถใช้ได้ถึงวันที่ 30 เม.ย. 2563</div>
                </div>
              <div class="d-flex justify-content-end mt-4">
                <el-button type="primary" @click="subscribe">Subscribe</el-button>
              </div>
            </div>
        </div>
        <div class="modal-backdrop"></div>
      </div>
    </div>
  </transition>

  </div>
</template>

<script>
import CityTextField from '@/components/search-condition/CityTextField.vue';
import CheckinCheckOut from '@/components/search-condition/CheckinCheckOut.vue';
import DepartureArrival from '@/components/search-condition/DepartureArrival.vue';
import HomeInfluencerPresetTabs from '@/components/HomeInfluencerPresetTabs.vue';
import Multiselect from 'vue-multiselect';
import axios from 'axios';

export default {
  data() {
    return {
      objects: [
        {
          image: require('@/assets/images/jiso-logo.png'),
        },
        {
          image: require('@/assets/images/jiso-logo.png'),
        },
        {
          image: require('@/assets/images/jiso-logo.png'),
        },
        {
          image: require('@/assets/images/jiso-logo.png'),
        },
        {
          image: require('@/assets/images/jiso-logo.png'),
        },
        {
          image: require('@/assets/images/jiso-logo.png'),
        },
        {
          image: require('@/assets/images/jiso-logo.png'),
        },
        {
          image: require('@/assets/images/jiso-logo.png'),
        },
        {
          image: require('@/assets/images/jiso-logo.png'),
        },
        {
          image: require('@/assets/images/jiso-logo.png'),
        },
        {
          image: require('@/assets/images/jiso-logo.png'),
        },
        {
          image: require('@/assets/images/jiso-logo.png'),
        },
      ],
      value: '',
      dateValue: '',
      dialogVisible: true,
      multiSelect: [],
      multiSelect2: [],
      num1: 0,
      num2: 0,
      num3: 0,
      num4: 0,
      num5: 0,
      num6: 0,
      num7: 0,
      num8: 0,
      num9: 0,
      showDate: false,
      isActive: false,
      options: [
        {
          value: 'Y',
          label: 'Economy',
        },
        {
          value: 'C',
          label: 'Business',
        },
        {
          value: 'F',
          label: 'First',
        },
      ],
      items: [
        {
          value: 'Y',
          label: 'Economy',
        },
        {
          value: 'C',
          label: 'Business',
        },
        {
          value: 'F',
          label: 'First',
        },
      ],
      items2: [
        {
          value: 'Y',
          label: 'Economy',
        },
        {
          value: 'C',
          label: 'Business',
        },
        {
          value: 'F',
          label: 'First',
        },
      ],
      transport: [
        {
        value: 'Y',
        label: 'bus',
        },
        {
          value: 'C',
          label: 'train',
        },
        {
          value: 'F',
          label: 'car rental',
        },
        {
          value: 'G',
          label: 'ferry',
        },
        {
          value: 'H',
          label: 'boat',
        },
        {
          value: 'I',
          label: 'hericopter',
        },
      ],
      email: '',
    }
  },
  components: {
    CityTextField,
    DepartureArrival,
    CheckinCheckOut,
    Multiselect,
    HomeInfluencerPresetTabs,
  },
  methods: {
    update(selected) {
      this.value = selected;
    },
    subscribe() {
      // console.log(this.email);
      this.dialogVisible = false;
      console.log(this.email);
      axios.get('https://yuzudigital.com/test/php/jisoCustomerEmail.php?email=' + this.email).then((response) => {
        console.log(response.data)
      })
    },
    showUp() {
      this.isActive = !this.isActive;
    },
    submitSearchFlight() {
      window.open('https://flight.jisotravel.com/start', '_blank');
      alert('Preference: ' + this.multiSelect + ' Group Type: ' + this.value +
      ' Adult: ' + this.num1 + ' Child: ' + this.num2 + ' Infants: ' + this.num3)
    },
    submitSearchTrip() {
      // window.open('https://app.jisotravel.com/app/presets', '_blank');
      alert('Preference: ' + this.multiSelect + ' Group Type: ' + this.value +
      ' Adult: ' + this.num1 + ' Child: ' + this.num2 + ' Infants: ' + this.num3)
    },
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
  @import '@/assets/start.scss';
</style>